export const primary = {
    main: '#c1dfff',
    dark: '#90adcc',
    light: '#f4ffff',
}

export const secondary = {
    main: '#fff869',
    light: '#ffff9b',
    dark: '#c9c536',
}

export const error = {
    main: '#db2624',
}

export const background = {
    default: '#fdf9f6',
}
